import '../styles/pages/_user-agreement.scss';
import 'RSV';
import { DOMUtils } from '../utils/dom-utils.js';
import { APIUtils } from '../utils/api-utils.js';

const {
  getElementById,
  querySelector,
  querySelectorAll,
  getValue,
  setValue,
  attr,
  setChecked,
  removeAttr,
  createElement,
  getElementsAsObject,
  ready,
} = DOMUtils;

const { get } = APIUtils;

/**
 * User Agreement module for handling registration forms
 */
class UserAgreementManager {
  constructor() {
    this.rules = [];
    this.elements = {};
  }

  init() {
    this.cacheElements();
    this.bindEvents();
  }

  cacheElements() {
    this.elements = getElementsAsObject({
      debugPeriod: 'debug_period',
      emailField: 'email',
      registrationForm: 'registration',
      plotField: 'plot',
    });
  }

  bindEvents() {
    const { emailField, registrationForm } = this.elements;

    if (emailField) {
      emailField.addEventListener('blur', this.getGardener.bind(this));
    }

    if (registrationForm) {
      registrationForm.addEventListener('submit', this.submitAgreement.bind(this));
    }
  }

  setDebug(args = {}) {
    const { debugPeriod } = this.elements;
    if (debugPeriod) {
      const isRenewal = debugPeriod.value === 'renewal';
      const isVisible = debugPeriod.style.display !== 'none' && debugPeriod.offsetParent !== null;
      console.log(`debug: renewal=${isRenewal}, visible=${isVisible}`);

      if (isRenewal) {
        args.r = '@';
      }
      if (isVisible) {
        args.d = '+';
      }
    }
    return args;
  }

  async getGardener(e) {
    const email = e.target.value;
    if (email && window.rsv && window.rsv.isValidEmail(email)) {
      const { debugPeriod } = this.elements;
      let url = `/api/v2/find-gardener/${email.toLowerCase().trim()}`;

      if (debugPeriod && debugPeriod.value === 'renewal') {
        url += '/renewal';
      }

      try {
        const data = await get(url);
        this.displayRegistration(data);
      } catch (error) {
        console.error('Error fetching gardener:', error);
      }
    }
  }

  submitAgreement(e) {
    querySelectorAll('#garden_sites input').forEach((input) => removeAttr(input, 'disabled'));
    querySelectorAll('.renewal input').forEach((input) => removeAttr(input, 'disabled'));
    return window.rsv ? window.rsv.validate(e, this.rules) : true;
  }

  setCheckedElement(selector) {
    const element = querySelector(selector);
    if (element) {
      setChecked(element, true);
    }
  }

  setDisabled(selector) {
    const element = querySelector(selector);
    if (element) {
      attr(element, 'disabled', 'disabled');
      element.disabled = true;
    }
  }

  radioToCheckbox(gardens) {
    querySelectorAll('#garden_sites input[type="radio"]').forEach((radio) => {
      const attrs = { type: 'checkbox' };
      const _id = radio.id;

      Array.from(radio.attributes).forEach((attribute) => {
        if (attribute.nodeName !== 'type') {
          attrs[attribute.nodeName] = attribute.nodeValue;
        }
      });

      const checkbox = createElement('input', attrs);

      radio.parentNode.replaceChild(checkbox, radio);

      if (gardens.indexOf(_id) !== -1) {
        this.setCheckedElement(`#garden_sites input[type="checkbox"]#${_id}`);
      }
    });
  }

  displayRegistration(gardener) {
    if (gardener.site === 'waitinglist') {
      return;
    }

    this.setDisabled('.renewal input');
    this.setDisabled('#garden_sites input');

    ['firstname', 'lastname', 'phone', 'garden_list'].forEach((field) => {
      if (gardener[field]) {
        setValue(field, gardener[field]);
      }
    });

    this.setCheckedElement(`#${gardener.site}`);

    if (gardener.renewal) {
      querySelectorAll('.renewal').forEach((el) => (el.style.display = 'block'));
      this.setCheckedElement('#renewal');

      ['plot', 'garden_list'].forEach((field) => {
        if (gardener[field]) {
          setValue(field, gardener[field]);
        }
      });

      const { plotField } = this.elements;
      if (plotField) {
        attr(plotField, 'size', '9');

        if (plotField.value === '0' && gardener.plots) {
          setValue('plot', gardener.plots.join(','));
        }
      }

      const gardens = getValue('garden_list');

      if (gardens && gardens !== '') {
        this.radioToCheckbox(gardens);
      }

      const submitButton = getElementById('submit');
      if (submitButton) {
        setValue('submit', 'Renew');
      }
    }
  }
}

// Export for testing
export { UserAgreementManager };

// Initialize when DOM is ready
ready(() => {
  const userAgreementManager = new UserAgreementManager();
  userAgreementManager.init();
});
